import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

const KIND_LABEL = { emails: "Emails", leads: "Leads", chats: "Chats" };

export default function UsageBar({ usage, compact }) {
  if (!usage) return null;
  const isPro = usage.plan === "pro";
  return (
    <div className={`cell-strong bg-white ${compact ? "p-4" : "p-6"}`} data-testid="usage-bar">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="overline text-[var(--ink-soft)]">/ This month · {usage.period}</div>
          <div className="font-display text-xl mt-1">
            {usage.plan_label} plan
            {isPro && <span className="tag tag-yellow ml-2">UNLIMITED</span>}
          </div>
        </div>
        {!isPro && (
          <Link to="/pricing" className="text-xs font-mono-rc tracking-wide uppercase underline" data-testid="usage-upgrade-link">
            Upgrade →
          </Link>
        )}
      </div>
      <div className={`grid ${compact ? "grid-cols-3" : "grid-cols-3"} gap-3`}>
        {["emails", "leads", "chats"].map((k) => (
          <Meter key={k} label={KIND_LABEL[k]} kind={k} used={usage.used[k]} limit={usage.limits[k]} percent={usage.percent[k]} />
        ))}
      </div>
    </div>
  );
}

function Meter({ label, kind, used, limit, percent }) {
  const isUnlimited = limit === null || limit === undefined;
  const isExhausted = !isUnlimited && used >= limit;
  const isWarn = !isUnlimited && percent >= 80 && !isExhausted;
  const barColor = isExhausted ? "var(--bad)" : isWarn ? "#F59E0B" : "var(--brand)";
  return (
    <div data-testid={`usage-meter-${kind}`}>
      <div className="flex items-baseline justify-between text-xs mb-1">
        <span className="overline text-[var(--ink-soft)]">{label}</span>
        <span className="font-mono-rc">
          {used.toLocaleString()}
          {!isUnlimited && <span className="text-[var(--ink-soft)]"> / {limit.toLocaleString()}</span>}
        </span>
      </div>
      <div className="h-2 bg-[var(--bg-soft)] border border-[var(--ink)] relative overflow-hidden">
        <div
          className="h-full transition-all"
          style={{
            width: isUnlimited ? "100%" : `${Math.min(100, percent)}%`,
            background: isUnlimited ? "var(--accent)" : barColor,
          }}
        />
      </div>
      {isExhausted && (
        <div className="text-xs mt-1.5 text-[var(--bad)] font-medium flex items-center gap-1">
          Quota exhausted —
          <Link to="/pricing" className="underline" data-testid={`usage-exhausted-${kind}`}>upgrade <ArrowRight size={10} weight="bold" /></Link>
        </div>
      )}
      {isWarn && (
        <div className="text-xs mt-1.5 text-amber-700 font-medium">
          {percent}% used — consider upgrading.
        </div>
      )}
    </div>
  );
}
